"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthHistoryCaseDtoSideEnum = exports.HealthHistoryCaseDtoRelationshipEnum = void 0;
exports.HealthHistoryCaseDtoRelationshipEnum = {
    Self: 'Self',
    Mother: 'Mother',
    Father: 'Father',
    Brother: 'Brother',
    Sister: 'Sister',
    Grandson: 'Grandson',
    Granddaughter: 'Granddaughter',
    PartnerMale: 'Partner (Male)',
    PartnerFemale: 'Partner (Female)',
    Son: 'Son',
    Daughter: 'Daughter',
    CousinMale: 'Cousin (Male)',
    CousinFemale: 'Cousin (Female)',
    Nephew: 'Nephew',
    Niece: 'Niece',
    Uncle: 'Uncle',
    Aunt: 'Aunt',
    HalfBrother: 'Half-brother',
    HalfSister: 'Half-sister',
    Grandfather: 'Grandfather',
    Grandmother: 'Grandmother'
};
exports.HealthHistoryCaseDtoSideEnum = {
    Maternal: 'Maternal',
    Paternal: 'Paternal'
};
